export { default as Login } from '../components/Login';
export { default as Registration } from '../components/Registration';
export { default as ForgottenPassword } from '../components/ForgottenPassword';
export { default as ChangePassword } from '../components/ChangePassword';
export { default as UserMainPage } from '../components/UserMainPage';
export { default as ProjectsPage } from '../components/Projects/ProjectsPage';
export { default as SettingsPage } from '../components/Settings/SettingsPage';
export { default as ManagerialDecisionsPage }
  from '../components/ManagerialDecisions/ManagerialDecisionsPage';
export { default as MissingLicenceWarning } from '../components/MissingLicenceWarning';